var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('photo-gallery',{attrs:{"gallery-type":"GuideBookPaper","gallery-id":_vm.guideBookPaper.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }